import { Timestamp } from '@dadohr/shared/domainTypes/time';
import React, { createContext, ReactNode, useContext, useState } from 'react';

export type EmployeeAppLocalUpdatesForInstance = {
  msgs: {
    [msgId: string]: {
      markedAsRead: {
        at: Timestamp;
        read: boolean;
      };
    };
  };
};

export type EmployeeAppLocalUpdates = {
  [instanceAccessToken: string]: EmployeeAppLocalUpdatesForInstance;
};

type LocalUpdateContextType = {
  updates: EmployeeAppLocalUpdates;
  setUpdates: React.Dispatch<React.SetStateAction<EmployeeAppLocalUpdates>>;
};

const LocalUpdateContext = createContext<LocalUpdateContextType | undefined>(
  undefined
);

export const LocalUpdateProvider = ({ children }: { children: ReactNode }) => {
  const [updates, setUpdates] = useState<EmployeeAppLocalUpdates>({});

  return (
    <LocalUpdateContext.Provider value={{ updates, setUpdates }}>
      {children}
    </LocalUpdateContext.Provider>
  );
};

export const useLocalUpdates = () => {
  const context = useContext(LocalUpdateContext);
  if (context === undefined) {
    throw new Error(
      'useLocalUpdates must be used within a LocalUpdateProvider'
    );
  }
  return context;
};
